// frontend_react/src/services/socket.js

import { io } from "socket.io-client";

let socket;

export function getSocket() {
  if (!socket) {
    socket = io("https://stag.queens-games.com", {
      path: "/socket.io/",
      transports: ["polling", "websocket"],
      withCredentials: true,
      reconnection: true,
      reconnectionAttempts: 5,
      reconnectionDelay: 1000,
    });

    socket.on("connect", () => {
      console.log("✅ SOCKET CONNECTED", socket.id);
    });

    socket.on("connect_error", (err) => {
      console.error("❌ SOCKET ERROR", err.message);
    });
  }

  return socket;
}

export const joinRoom = (room) => {
  const s = getSocket();
  s.emit("join", room);
};